/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */

/**
 * @file 运营位json过滤
 */

import { SlugDate, now, isEmpty } from '@tencent/slug-function';

interface JsonItem {
  id: string;
  start_time: string;
  end_time: string;
  [propName: string]: any;
}

/**
 * 根据开始结束时间过滤
 * @param json 要过滤的数据，数组
 * @param type 过滤类型，取值 1 | 2 | 3，默认值为 1
 *
 * 1-未开始、已结束的都过滤掉 2-仅过滤已结束的 3-仅过滤未开始的
 * @returns 返回过滤后的数组
 *
 * @example jsonFilterByTime(data) // => data
 */
export const jsonFilterByTime = (json: JsonItem[], type = 1): JsonItem[] => {
  if (isEmpty(json)) return [];

  return json.filter((item) => {
    const { start_time, end_time, startTime, endTime } = item;
    const start = new SlugDate(start_time || startTime).getTime();
    const end = new SlugDate(end_time || endTime).getTime();

    const noStart = start > now();
    const isEnd = end < now();

    // 仅过滤已结束的
    if (type === 2) return !isEnd;
    // 仅过滤未开始的
    if (type === 3) return !noStart;
    // 未开始或已结束的不要
    return !noStart && !isEnd;
  });
};
